import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AuthSplitFrame } from '../features/auth/AuthSplit';

/**
 * The layout the sign-in screens share: login, MFA and signup.
 *
 * Pathless, so it adds nothing to a URL and nothing to the guard in `__root.tsx`, which still
 * decides by pathname. It exists so the frame and its showcase belong to the layout rather than
 * to a page, and survive navigating between them — see `AuthSplitFrame`.
 */
export const Route = createFileRoute('/_auth')({
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <AuthSplitFrame>
      <Outlet />
    </AuthSplitFrame>
  );
}
